"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withCurrencySign = exports.withoutCurrencySign = exports.getPositiveRoundedNumber = exports.stringToNumber = exports.getFractionAsString = exports.groupDigits = exports.addExtraZeros = exports.numberToIntegerAndFraction = void 0;
var _round = require("round10");
var groupDigits = function groupDigits(_ref) {
  var digits = _ref.digits,
    groupSize = _ref.groupSize,
    groupSeparator = _ref.groupSeparator,
    _ref$leftToRight = _ref.leftToRight,
    leftToRight = _ref$leftToRight === void 0 ? false : _ref$leftToRight;
  // E.g. '12345678' => '12,345,678'
  var array = leftToRight ? digits.split('') : digits.split('').reverse(); // eslint-disable-line fp/no-mutating-methods

  var arraySize = Math.ceil(array.length / groupSize);
  var formattedString = groupSize < 1 ? digits : Array(arraySize).fill().map(function (_, index) {
    return array.slice(index * groupSize, index * groupSize + groupSize);
  }).map(function (group) {
    return group.join('');
  }).join(groupSeparator);
  return leftToRight ? formattedString : formattedString.split('').reverse().join(''); // eslint-disable-line fp/no-mutating-methods
};

exports.groupDigits = groupDigits;
var getFractionAsString = function getFractionAsString(number) {
  // E.g. 12.3456 => '3456'
  var numberWithFraction = Number.isInteger(number) ? "".concat(number, ".0") : number;
  return (numberWithFraction - Math.trunc(numberWithFraction)).toFixed("".concat(numberWithFraction).split('.')[1].length).slice(number < 0 ? 3 : 2);
}; // E.g. '123' => '0000123'

exports.getFractionAsString = getFractionAsString;
var addExtraZeros = function addExtraZeros(_ref2) {
  var number = _ref2.number,
    digits = _ref2.digits,
    _ref2$position = _ref2.position,
    position = _ref2$position === void 0 ? 'end' : _ref2$position;
  return "".concat(number)[position === 'end' ? 'padEnd' : 'padStart'](digits, '0');
};
exports.addExtraZeros = addExtraZeros;
var numberToIntegerAndFraction = function numberToIntegerAndFraction(_ref3) {
  var number = _ref3.number,
    fractionDigits = _ref3.fractionDigits,
    integerDigits = _ref3.integerDigits,
    groupSeparator = _ref3.groupSeparator;
  var integerPart = Math.trunc(number);
  var integerPartWithLeadingZeros = addExtraZeros({
    number: integerPart,
    digits: integerDigits,
    position: 'start'
  });
  var groupedIntegerPart = groupDigits({
    digits: integerPartWithLeadingZeros,
    groupSize: 3,
    groupSeparator: groupSeparator
  });
  var fractionPart = getFractionAsString(number);
  var fractionPartWithTailingZeros = addExtraZeros({
    number: fractionPart,
    digits: fractionDigits
  });
  var groupedFractionPart = groupDigits({
    digits: fractionPartWithTailingZeros,
    groupSize: 3,
    groupSeparator: groupSeparator,
    leftToRight: true
  });
  return {
    integer: groupedIntegerPart,
    fraction: groupedFractionPart
  };
};
exports.numberToIntegerAndFraction = numberToIntegerAndFraction;
var stringToNumber = function stringToNumber(string) {
  return Number(string);
};
exports.stringToNumber = stringToNumber;
var getPositiveRoundedNumber = function getPositiveRoundedNumber(_ref4) {
  var hasPercent = _ref4.hasPercent,
    numberToFormat = _ref4.numberToFormat,
    precision = _ref4.precision;
  return Math.abs((0, _round.round10)(hasPercent ? numberToFormat * 100 : numberToFormat, precision));
};
exports.getPositiveRoundedNumber = getPositiveRoundedNumber;
var withoutCurrencySign = function withoutCurrencySign(_ref5) {
  var hasPercent = _ref5.hasPercent,
    number = _ref5.number;
  return hasPercent ? "".concat(number, "%") : "".concat(number);
};
exports.withoutCurrencySign = withoutCurrencySign;
var withCurrencySign = function withCurrencySign(_ref6) {
  var currencyPosition = _ref6.currencyPosition,
    currency = _ref6.currency,
    number = _ref6.number;
  return currencyPosition === 'start' ? "".concat(currency).concat(number) : "".concat(number).concat(currency);
};
exports.withCurrencySign = withCurrencySign;